import { render, staticRenderFns } from "./FilesBar.vue?vue&type=template&id=4ad2c11e&scoped=true&"
import script from "./FilesBar.vue?vue&type=script&lang=js&"
export * from "./FilesBar.vue?vue&type=script&lang=js&"
import style0 from "./FilesBar.vue?vue&type=style&index=0&id=4ad2c11e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad2c11e",
  null
  
)

export default component.exports